import { Grid, styled } from "@mui/material";

export const RecipientsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  marginLeft: "10px",
});

export const SingleRecipient = styled(Grid)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
  "& .MuiIconButton-root": {
    opacity: 0,
  },
  "&:hover": {
    "& .MuiIconButton-root": {
      opacity: 1,
    },
  },
});

export const Container = styled(Grid)({
  display: "flex",
  gap: "10px",
  width: "100%",
  paddingTop: "10px",
});

export const Block = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "50%",
  gap: "10px",
});
